import React from 'react';
import { BookOpenIcon, TrendingUpIcon, BarChartIcon } from 'lucide-react';
import { MathsBadge } from '../shared/MathsBadge';
export function WhyParticipateSection() {
  return <section className="py-20 bg-white" data-id="element-444">
      <div className="container mx-auto px-4" data-id="element-445">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-446">
          <div data-id="element-447">
            <div className="inline-flex items-center px-3 py-1.5 bg-purple-100 rounded-full mb-4" data-id="element-448">
              <span className="text-purple-700 font-medium" data-id="element-449">
                Why Join the Study
              </span>
            </div>
            <h2 className="text-3xl font-bold mb-4" data-id="element-450">📣 Why Join the Study?</h2>
            <div className="w-16 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mb-6" data-id="element-451"></div>
            <p className="text-lg text-purple-700 font-medium mb-4" data-id="element-452">
              Be part of a nationally significant Randomised Controlled Trial
              (RCT) shaping the future of maths education in the UK.
            </p>
            {/* Highlights box */}
            <div className="bg-gray-50 p-6 rounded-xl shadow-sm mb-6 border-l-4 border-purple-500" data-id="element-453">
              <h3 className="font-bold text-gray-800 mb-3" data-id="element-454">Key Highlights</h3>
              <ul className="space-y-2" data-id="element-455">
                <li className="flex items-center" data-id="element-456">
                  <span className="text-purple-500 mr-2" data-id="element-457">✓</span>
                  <span className="text-gray-700" data-id="element-458">
                    Completely free to participate
                  </span>
                </li>
                <li className="flex items-center" data-id="element-459">
                  <span className="text-purple-500 mr-2" data-id="element-460">✓</span>
                  <span className="text-gray-700" data-id="element-461">
                    Financial reward for your school
                  </span>
                </li>
                <li className="flex items-center" data-id="element-462">
                  <span className="text-purple-500 mr-2" data-id="element-463">✓</span>
                  <span className="text-gray-700" data-id="element-464">
                    Premium access to cutting-edge tools
                  </span>
                </li>
                <li className="flex items-center" data-id="element-465">
                  <span className="text-purple-500 mr-2" data-id="element-466">✓</span>
                  <span className="text-gray-700" data-id="element-467">
                    Dedicated support throughout
                  </span>
                </li>
              </ul>
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-468">
              Your school will:
            </p>
            <div className="space-y-4 mb-6" data-id="element-469">
              <div className="flex items-start group hover:bg-purple-50 p-3 rounded-lg transition-colors" data-id="element-470">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3 mt-0.5 group-hover:bg-purple-200 transition-colors" data-id="element-471">
                  <TrendingUpIcon className="w-5 h-5 text-purple-600" data-id="element-472" />
                </div>
                <div data-id="element-473">
                  <p className="text-gray-800 font-medium" data-id="element-474">
                    Contribute to a major evidence-building project
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-475">
                    Help improve maths outcomes across the UK
                  </p>
                </div>
              </div>
              <div className="flex items-start group hover:bg-purple-50 p-3 rounded-lg transition-colors" data-id="element-476">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3 mt-0.5 group-hover:bg-purple-200 transition-colors" data-id="element-477">
                  <BookOpenIcon className="w-5 h-5 text-purple-600" data-id="element-478" />
                </div>
                <div data-id="element-479">
                  <p className="text-gray-800 font-medium" data-id="element-480">
                    Receive free Eedi Plus access
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-481">
                    For all KS3 teachers and students, including live 1-to-1
                    tutor support and additional payment
                  </p>
                </div>
              </div>
              <div className="flex items-start group hover:bg-purple-50 p-3 rounded-lg transition-colors" data-id="element-482">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3 mt-0.5 group-hover:bg-purple-200 transition-colors" data-id="element-483">
                  <BarChartIcon className="w-5 h-5 text-purple-600" data-id="element-484" />
                </div>
                <div data-id="element-485">
                  <p className="text-gray-800 font-medium" data-id="element-486">
                    Gain detailed insights into pupil progress
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-487">
                    Identify and address misconceptions with powerful analytics
                    and free access to reliable and standardised STAR
                    assessments
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col" data-id="element-488">
            <div className="relative" data-id="element-489">
              <div className="absolute -top-4 -left-4 w-full h-full bg-gradient-to-br from-purple-200 to-blue-200 rounded-lg opacity-50 transform rotate-3" data-id="element-490"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nnrPJN1T3tAAW91XEV99dY/Simplified_student_UI.png" alt="Student Interface" className="rounded-lg shadow-lg max-w-full h-auto relative z-10" data-id="element-491" />
              {/* Math badge decoration */}
              <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hbDxMqqjy4GvnSrLfyXzyY/Rocket.png" altText="Math Rocket Badge" size="large" className="absolute -top-10 -right-10 z-20" data-id="element-492" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}